import { render } from "./PriceVolume.vue?vue&type=template&id=39dcfabe"
import script from "./PriceVolume.vue?vue&type=script&lang=js"
export * from "./PriceVolume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__